import { IconCloudOff } from "@dfp/react-icons";

import { useTT } from "../useTT.ts";
import { ErrorPageContent } from "./ErrorPageContent.tsx";

export function ErrorUnreachableServerContent() {
  // Use errors namespaces as it is always preloaded, in the case of network error we can't download any other translations
  const { tt } = useTT();

  return (
    <ErrorPageContent
      graphic={<IconCloudOff height={64} width={64} />}
      title={tt("genericErrors.serverUnreachable")}
      description={tt("genericErrors.serverUnreachableLong")}
    />
  );
}
